// src/components/DataLoader.tsx
import { ReactNode, useEffect, useState } from "react";
import { Box, LinearProgress } from "@mui/material";
import { useSelectContext } from "@/contexts/useSelectContext";
import { useApiFetchSelect } from "@/hooks/use-api-fetch-select";

type DataLoaderProps = {
  children: ReactNode;
};

export const DataLoader = ({ children }: DataLoaderProps) => {
  const [isLoading, setIsLoading] = useState(true);
  const { setGlobalsSecrets } = useSelectContext();

  const { data: globalsSecrets, loading } = useApiFetchSelect({
    endpoint: "secret/globals",
    options: { realPath: true },
  });

  useEffect(() => {
    if (!loading) {
      if (Array.isArray(globalsSecrets)) {
        const sorted = [...globalsSecrets].sort((a, b) =>
          (a.v ?? "").localeCompare(b.v ?? "")
        );
        setGlobalsSecrets(sorted);
      } else {
        setGlobalsSecrets([]);
      }
      setIsLoading(false);
    }
  }, [loading, globalsSecrets, setGlobalsSecrets]);

  if (isLoading) {
    return (
      <Box sx={{ width: "100%" }}>
        <LinearProgress />
      </Box>
    );
  }

  return <>{children}</>;
};
